import OpenAI from 'openai';

// OpenAIクライアントの初期化
const openai = new OpenAI({
  apiKey: process.env.REACT_APP_OPENAI_API_KEY,
  dangerouslyAllowBrowser: true // ブラウザ環境での使用を許可
});

export const getAIAssistance = async (code, error) => {
  try {
    const response = await openai.chat.completions.create({
      model: "gpt-3.5-turbo",
      messages: [
        {
          role: "system",
          content: "あなたは親切なプログラミング講師です。初心者に優しく、わかりやすく教えてください。エラーの説明と解決策を提供してください。"
        },
        {
          role: "user",
          content: `以下のJavaScriptコードにエラーがあります：\n\n${code}\n\nエラー：${error.message}\n\nこのエラーを解決するためのアドバイスをください。`
        }
      ],
      temperature: 0.7,
      max_tokens: 500
    });

    return response.choices[0].message.content;
  } catch (error) {
    console.error('API Error:', error);
    return 'AIアシスタントに接続できませんでした。しばらく待ってから再度お試しください。';
  }
};